import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["readStatus"];
  static values = {
    accountId: Number,
    eventId: Number,
    done: Boolean
  };

  connect() {
    if (this.doneValue) {
      this.loadStatus();
    }
  }

  async loadStatus() {
    try {
      const response = await fetch(
        `/accounts/${this.accountIdValue}/mautic_emails/${this.eventIdValue}/status`,
        { headers: { Accept: "application/json" }, credentials: "same-origin" }
      );
      const data = await response.json();

      if (data.error) return;

      let text = "";
      if (data.read) {
        text = ` · Visualizado`;
        if (data.date_read) {
          const date = new Date(data.date_read);
          text += ` em ${date.toLocaleDateString("pt-BR")}`;
        }
      } else if (data.sent) {
        text = ` · Ainda não visualizado`;
      }

      if (data.clicks > 0) {
        text += ` · ${data.clicks} clique${data.clicks > 1 ? "s" : ""}`;
      }

      this.readStatusTarget.textContent = text;
      this.readStatusTarget.className = data.read ? "text-blue-600" : "text-gray-500";
    } catch (e) {
      console.error(e);
    }
  }
}
